var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAwardRankerBg = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 25,
    fill: "none",
    viewBox: "0 0 180 25",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#award-ranker-bg_svg__a)",
    fillRule: "evenodd",
    d: "M180 0H0l18 25h144z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "award-ranker-bg_svg__a",
    x1: 8.5,
    x2: 38.111,
    y1: 13,
    y2: 76.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ca2e8",
    stopOpacity: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a84ff"
  })))));
};
export default SvgAwardRankerBg;